import { render, staticRenderFns } from "./fl44-notice-card.vue?vue&type=template&id=690a9c0c&scoped=true&"
import script from "./fl44-notice-card.vue?vue&type=script&lang=js&"
export * from "./fl44-notice-card.vue?vue&type=script&lang=js&"
import style0 from "./fl44-notice-card.vue?vue&type=style&index=0&id=690a9c0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690a9c0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('690a9c0c')) {
      api.createRecord('690a9c0c', component.options)
    } else {
      api.reload('690a9c0c', component.options)
    }
    module.hot.accept("./fl44-notice-card.vue?vue&type=template&id=690a9c0c&scoped=true&", function () {
      api.rerender('690a9c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/fl44-notices/partials/fl44-notice-card.vue"
export default component.exports